import { useEffect, useState } from "react";
import { toast } from "sonner";
import ReportKPIs, { useReportMetrics } from "@/components/reports/ReportKPIs";
import ReportCharts from "@/components/reports/ReportCharts";
import ReportEditor from "@/components/reports/ReportEditor";
import RevisionChat from "@/components/reports/RevisionChat";
import { saveReportContent } from "@/lib/reports";

/** Moteur UI universel : KPIs + graphiques (inclusion PDF) + texte éditable + chat de révision. */
export default function ReportShell({ dossierId, sessionId, kind, content, onContentChange, charts, onChartsChange, streaming, children }) {
    const { data, loading } = useReportMetrics(dossierId);
    const [sel, setSel] = useState(charts || []);
    useEffect(() => { setSel(charts || []); }, [charts, sessionId]);

    async function toggle(key) {
        const next = sel.includes(key) ? sel.filter((k) => k !== key) : [...sel, key];
        setSel(next); onChartsChange?.(next);
        if (sessionId) {
            try { await saveReportContent(dossierId, sessionId, kind, { charts: next }); }
            catch (e) { toast.error("Sélection non enregistrée", { description: e.message }); }
        }
    }

    const ready = !!sessionId && !streaming && !!content;
    return (
        <div data-testid={`report-shell-${kind}`} className="space-y-4">
            <ReportKPIs data={data} loading={loading} />
            <ReportCharts history={data?.history} selected={sel} onToggle={toggle} disabled={streaming} />
            {children}
            {content ? (
                ready ? <ReportEditor dossierId={dossierId} sessionId={sessionId} kind={kind} content={content} onChange={onContentChange} /> : <ReportEditor dossierId={dossierId} sessionId={sessionId} kind={kind} content={content} onChange={onContentChange} readOnly />
            ) : null}
            {ready && <RevisionChat dossierId={dossierId} sessionId={sessionId} kind={kind} onRevised={onContentChange} />}
        </div>
    );
}
